<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-title>Missing Requirements</v-title>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader>
              Products Details are required to generate quote
            </v-subheader>
          </v-flex>
          <v-flex xs12>
            <ul>
              <li v-for="(item, index) in requirements" :key="index">
                {{ item.text }}
                <v-btn
                  small
                  color="primary"
                  @click="navigate(item.path[0], item.callback)"
                >
                  Edit
                </v-btn>
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="navigate('create-ipvoice')">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { debug } from 'logrocket';
import { mapState } from 'vuex';

export default {
  name: 'QuotesValidation',
  data() {
    return {
      requirements: [],
      dialog: false,
    };
  },
  computed: {
    ...mapState('orders', ['summary']),
  },
  methods: {
    navigate(path, callback) {
      let vm = this;
      vm.closeModal();

      if (callback) {
        callback();
      }

      vm.$router.push(path);
    },
    closeModal() {
      let vm = this;
      vm.show = false;
    },
    validateOrder() {
      let vm = this;
      return new Promise((resolve, reject) => {
        let summary = vm.summary.reportView;

        if (!summary.quote) {
          vm.requirements.push({
            text: 'Missing Quote Details',
            path: ['/quote-details'],
          });
        }

        if (
          summary.contractedValues.length == 0 &&
          !summary.churns &&
          !summary.cmcs &&
          !summary.faxes &&
          !summary.hardware &&
          !summary.iPExtensions &&
          !summary.inbounds &&
          !summary.internets &&
          !summary.isdn &&
          !summary.mobiles &&
          !summary.newServices &&
          !summary.sip &&
          !summary.ports &&
          !summary.teams &&
          summary.installationCharges.length == 0
        ) {
          vm.requirements.push({
            text: 'Must have product details/orders',
            path: ['/create-ipvoice'],
          });
        }

        vm.dialog = vm.requirements.length > 0;
        resolve(vm.dialog);
      });
    },
  },
};
</script>

<style scoped></style>
